import React, { Component } from 'react';
import './PresetMenuBar.css'

export default class PresetMenuBar extends Component {
    handleOnClick = (section) => (e) => {
        this.props.onMenuChange(section);
    }
    render() {
        const section = this.props.section;
        return (
            <div className="PresetMenuBar" >
                <ul>
                    <li className={section==="preset" ? "selected" : ""} onClick={this.handleOnClick('preset')}>SBIおすすめスクリーナー</li>
                    <li className={section==="custom" ? "selected" : ""} onClick={this.handleOnClick('custom')}>Myスクリーナー</li>
                </ul>
                <a href="https://search.sbisec.co.jp/v2/popwin/info/trading/pop_domestic_screening_01.html" target="_blank"><div className="screenerhelpbtn" >ヘルプ</div></a>
            </div>
        );
    }
}